/**
 * yupバリデーションschemaのショートハンド
 */
import * as yup from 'yup'
import { transformToNumber } from 'ui/utils/PostalCodeToAddress'
import i18n from 'i18next'

export const text = () => yup.string().trim().max(100)

export const textRequired = () => text().nullable().required()

export const postalCode = () =>
  yup
    .string()
    .trim()
    .transform((string) => {
      return transformToNumber(string)
    })
    .max(7)

export const phone = () =>
  yup
    .string()
    .trim()
    .max(13)
    .matches(/^0(\d{1,4}-\d{1,4}-\d{3,4}|\d{9,10})$/, {
      message: i18n.t('validation.正しい形式にしてください'),
      excludeEmptyString: true,
    })

export const numberSelectEmptyStringToNull = () =>
  yup
    .number()
    .transform((value, originalValue) => {
      if (typeof originalValue === 'string' && originalValue === '') {
        return null
      }
      return value
    })
    .nullable()

export const textHiragana = () =>
  textRequired().matches(/^[ぁ-んー]+$/, {
    message: i18n.t('validation.ひらがなを入力してください'),
  })

export const textAlphabet = () =>
  yup
    .string()
    .trim()
    .matches(/^[a-zA-Z ]+$/, {
      message: i18n.t('validation.半角英字を入力してください'),
    })

export const textPassword = () =>
  yup
    .string()
    .required()
    .min(8)
    .max(100)
    .matches(
      /^[0-9a-zA-Z]+$/,
      i18n.t('validation.半角英数字を入力してください')
    )

export const textNewPassword = (fieldNameToCompare: string) =>
  textPassword()
    .matches(/[0-9]+/, i18n.t('validation.数字が含まれていません'))
    .matches(/[a-zA-Z]+/, i18n.t('validation.アルファベットが含まれていません'))
    .when(fieldNameToCompare, (oldPass: string, schema: any) =>
      schema.test({
        test: (newPass: string) => newPass && oldPass !== newPass,
        message: i18n.t('validation.異なるパスワードを入力して下さい'),
      })
    )

export const passCode = () =>
  yup
    .string()
    .required()
    .matches(/^[0-9]{6}$/, i18n.t('validation.6桁の数字を入力してください'))

export const email = () =>
  text()
    .email()
    .required()
    .test(
      'is-carrier-mail',
      i18n.t('validation.正しい形式にしてください'),
      (string) => {
        if (typeof string !== 'string') return false
        const domain = string.split('@')[1]
        const excludeDomains = ['docomo.ne.jp', 'ezweb.ne.jp', 'softbank.ne.jp']
        return !excludeDomains.includes(domain)
      }
    )
    .matches(/^([\x20-\x7e]+)?$/, i18n.t('validation.正しい形式にしてください'))

const validationSchema = {
  text,
  textHiragana,
  textAlphabet,
  textRequired,
  textPassword,
  textNewPassword,
  postalCode,
  phone,
  numberSelectEmptyStringToNull,
  passCode,
  email,
}

export default validationSchema
